import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { useFulfillmentPlannerCustoms } from './use-fulfillment-planner-customs';
import { mapDispatchToOnClick, mapStateToOpen } from '../../containers/orders-drawer/sections/section-container-helper';
import { SellerProperties } from '../../store/seller/seller-properties';

import CustomsDeclarations from './index';

const sectionId = 'customs';

const mapStateToProps = (state, { fulfillmentPlanId: fpid, currentFulfillmentPlanId, open }) => {
  // We are having to do this because fulfillmentPlanId is not provided for combined orders.
  const fulfillmentPlanId = currentFulfillmentPlanId || fpid;

  const { defaultCurrencyCode, homeCountry: defaultCountryCode, defaultWeightUnit } = new SellerProperties({ state });

  const openObject = open === undefined || open === null ? mapStateToOpen(state, sectionId) : { open };

  return {
    defaultCountryCode,
    defaultCurrencyCode,
    defaultWeightUnit,
    fulfillmentPlanId,
    ...openObject,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ...mapDispatchToOnClick(dispatch, sectionId),
  };
};

const CustomsDeclarationContainerDisplay = ({ fulfillmentPlanId = '', readOnly = false, shouldShowCustoms, ...otherProps }) => {
  const includeCustomsWidget = shouldShowCustoms === undefined ? true : shouldShowCustoms;
  const { customs, needsCustoms, onSave, hideCustomsDeclarations } = useFulfillmentPlannerCustoms(fulfillmentPlanId);

  return (
    <>
      {!hideCustomsDeclarations && (
        <CustomsDeclarations
          customs={customs}
          fulfillmentPlanId={fulfillmentPlanId}
          needsCustoms={Boolean(needsCustoms && includeCustomsWidget)}
          readOnly={readOnly}
          saveCustoms={onSave}
          shouldShowCustoms={shouldShowCustoms}
          {...otherProps}
        />
      )}
    </>
  );
};

CustomsDeclarationContainerDisplay.propTypes = {
  fulfillmentPlanId: PropTypes.string,
  readOnly: PropTypes.bool,
  shouldShowCustoms: PropTypes.bool,
};

export const CustomsDeclarationContainer = connect(mapStateToProps, mapDispatchToProps);

export default CustomsDeclarationContainer(CustomsDeclarationContainerDisplay);
